// @ts-nocheck
import { getVaultBaseUrl, getHostsNeedToken } from '../utils/apiHostOverride';

const VAULT_BASE_URL = '/vault';
const BULK_UPLOAD_URL = `${VAULT_BASE_URL}/bulkupload`;
const AUTH_URL = `${VAULT_BASE_URL}/auth`;
const CUSTOM_ENTITY_URL = `${VAULT_BASE_URL}/custom-entity`;
const TEMPLATE_VERSION_URL = `${VAULT_BASE_URL}/template-version`;
const MODEL_ENTITY_URL = `${VAULT_BASE_URL}/model-entity`;
const BULK_TRANSITION_URL = `${VAULT_BASE_URL}/bulktransition`;
const LLM_URL = `${VAULT_BASE_URL}/llm`;

const BULK_UPDATE_URL = `${VAULT_BASE_URL}/bulkupdate`;
const C_LOCK_URL = `${VAULT_BASE_URL}/lock`;
const BULK_DOCUMENT_URL = `${VAULT_BASE_URL}/bulk-document`;
const ENTITY_SERVICE_URL = `${VAULT_BASE_URL}/entity-service`;
const DYNAMIC_TOOLBAR_URL = `${VAULT_BASE_URL}/dyn-toolbar`;
const CHANGE_REQUEST_IMPACT = `${VAULT_BASE_URL}/impact`;
const ENTITIES_URL = `${VAULT_BASE_URL}/entities`;
const ENTITY_KEY_GENERATION_URL = `${VAULT_BASE_URL}/key-generation`;
const RAD_URL = `${VAULT_BASE_URL}/reporting`;

const API_ENDPOINTS = {
  HOSTS_NEEDS_TOKEN: getHostsNeedToken(),
  MODULE_BASE_URL: {
    AUTH: getVaultBaseUrl(),
  },
  HOME_PAGE: {
    QUICK_LINK: '/auth/quick-link',
  },
  AUTH: {
    LOGIN_USER: `${AUTH_URL}/login/`,
    USER_DETAIL: `${AUTH_URL}/user-detail`,
    LOGOUT_USER: `${AUTH_URL}/logout/`,
    LOGOUT_USER_COMMON_AUTH: `/access-management/logout/`,
    CREATE_USER: `${AUTH_URL}/register/`,
    USER_PERMISSION: `${AUTH_URL}/getUserPermission`,
    UPDATE_USER: `${VAULT_BASE_URL}/profile/update/`,
    ROLE_LINKAGES_UPDATE: `${VAULT_BASE_URL}/roleLinkagesUpdate`,
    SUSPEND_USER: `${AUTH_URL}/suspend`,
    REFRESH_TOKEN: `${AUTH_URL}/token/refresh/`,
    REFRESH_TOKEN_COMMON_AUTH: `/access-management/refresh/`,
    FORGET_PASSWORD: `${AUTH_URL}/request_reset_email/`,
    RESET_PASSWORD: `${AUTH_URL}/password_reset_complete/`,
    USER_SETTING: `${AUTH_URL}/user-settings`,
    IS_LOGGED_IN_USER_ADMIN_OF_GROUP: `${AUTH_URL}/isAdmin`,
    VALIDATE_ACCOUNT: `${AUTH_URL}/get_details_for_sso`,
    SHARE_ACCESS: `${AUTH_URL}/shareAccess`,
    FRONTEND_CONFIG: `${AUTH_URL}/plugins`,
    IMPERSONATION_START: `${AUTH_URL}/impersonation/start`,
    IMPERSONATION_STOP: `${AUTH_URL}/impersonation/stop`,
    IMPERSONATION_STATUS: `${AUTH_URL}/impersonation/status`,
  },
  NOTIFICATIONS: {
    GET_NOTIFICATION: `${VAULT_BASE_URL}/notification/getAll`,
    GET_NOTIFICATION_COUNT: `${VAULT_BASE_URL}/notification/getCount`,
    CLEAR_NOTIFICATION: `${VAULT_BASE_URL}/notification/clearAll`,
    READ_UNREAD: `${VAULT_BASE_URL}/notification/Marksingleread`,
    MARK_ALL_READ: `${VAULT_BASE_URL}/notification/MarkAsRead`,
    GET_ALL_NOTIFICATIONS: `${VAULT_BASE_URL}/notification/manageAnnouncements`,
    SSE: '/sse/stream',
  },
  CE: {
    CREATE_ENTITY: CUSTOM_ENTITY_URL,
    GET_SINGLE_ENTITY: CUSTOM_ENTITY_URL,
    CREATE_SECTION: `${CUSTOM_ENTITY_URL}/section`,
    GET_SECTIONS_DETAILS: `${CUSTOM_ENTITY_URL}/section`,
    REMOVE_SECTION: `${CUSTOM_ENTITY_URL}/section`,
    GET_ATTRIBUTES: `${VAULT_BASE_URL}/get-attribute`,
    ATTACH_WORKFLOW: `${CUSTOM_ENTITY_URL}/workflow`,
    DELETE_TEMPLATE: CUSTOM_ENTITY_URL,
    REORDER_TEMPLATE: `${VAULT_BASE_URL}/orderRearrange`,
    GET_MODEL_DETAILS_OF_WORKFLOW_CHANGES: `${CUSTOM_ENTITY_URL}/updateworkflow`,
    TRANSITION_ALL_MODELS: `${CUSTOM_ENTITY_URL}/updateworkflow`,
    GET_WORKFLOW_ROLES: `${VAULT_BASE_URL}/workflow/getAllRoles`,
    CHECK_TEMPLATE: `${CUSTOM_ENTITY_URL}/checkTemplate`,
    IMPORT_TEMPLATE: `${CUSTOM_ENTITY_URL}/importTemplate`,
    DOWNLOAD_SAMPLE_TEMPLATE: `${CUSTOM_ENTITY_URL}/sampleTemplateExcel`,
    EXPORT_TEMPLATE: `${CUSTOM_ENTITY_URL}/exportTemplate`,
    ENTITY_TYPE_COUNTS: `${CUSTOM_ENTITY_URL}/entity-type-counts`,
    IMPORT_ATTRIBUTE: `${CUSTOM_ENTITY_URL}/importAttribute`,
    DOWNLOAD_SAMPLE_ATTRIBUTE: `${CUSTOM_ENTITY_URL}/SampleAttributesExcel`,
    EXPORT_ATTRIBUTE: `${CUSTOM_ENTITY_URL}/exportAttributes`,
    MODEL_MANAGEMENT: `${CUSTOM_ENTITY_URL}/model-management`,
    CYCLIC_PROCESS: `${CUSTOM_ENTITY_URL}/model-management/cycle-config`,
    ARTIFACT_PROCESS: `${VAULT_BASE_URL}/artifactprocess`,
    ARTIFACT_PROCESS_STATUS: `${VAULT_BASE_URL}/artifactprocessstatus`,
    HEALTH_DEFINITIONS: `${CUSTOM_ENTITY_URL}/health-definitions`,
    FORMULA_PLACEHOLDERS: `${CUSTOM_ENTITY_URL}/placeholders`,
    GLOBAL_ATTRIBUTES_REPORT: `${VAULT_BASE_URL}/global-attribute-report`,
    LOCAL_ATTRIBUTES_REPORT: `${VAULT_BASE_URL}/local-attribute-report`,
    GET_ATTRIBUTE_REPORTS: `${VAULT_BASE_URL}/report-list`,
    DOWNLOAD_REPORT: `${VAULT_BASE_URL}/Download-report`,
    GET_REPORT_TYPES: `${VAULT_BASE_URL}/get_filter_type`,
    GET_SUMMARY_SECTIONS_ATTRIBUTES_ORDER: `${CUSTOM_ENTITY_URL}/summary-sections`,
    ORDER_SUMMARY_SECTIONS_ATTRIBUTES_ORDER: `${CUSTOM_ENTITY_URL}/summary-attribute-order`,
    AVAILABLE_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/get_available_attributes`,
    IS_CYCLE_PROCESS_ENABLED: `${CUSTOM_ENTITY_URL}/model-management/is-cycle-enabled`,
    DYNAMIC_ENTITY_TYPE: `${ENTITY_KEY_GENERATION_URL}/entity-type-metadata`,
    ENTITY_TYPE_IMPACT_PREVIEW: `${ENTITY_KEY_GENERATION_URL}/entity-type-metadata/impact-preview`,
    CREATE_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/create`,
    GET_TEMPLATE_VERSIONS: `${TEMPLATE_VERSION_URL}/list`,
    SET_DEFAULT_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/set-default`,
    PUBLISH_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/publish`,
    MIGRATE_ENTITIES_TO_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/migrate`,
    COMPARE_TEMPLATE_VERSIONS: `${TEMPLATE_VERSION_URL}/compare`,
    GET_TEMPLATE_LIST: `${CUSTOM_ENTITY_URL}/get-all-templates`,
    GET_VERSIONS_COMMON_ATTRIBUTES: `${TEMPLATE_VERSION_URL}/get-common-attributes`,
    GET_VERSIONS_SECTIONS: `${VAULT_BASE_URL}/template/sections`,
    CHANGE_REQUEST_ATTR_BLACKLIST: `${CUSTOM_ENTITY_URL}/change-management/attribute-blacklist`,
  },
  MI: {
    GET_QUERY_LIST: `${VAULT_BASE_URL}/query/list`,
    SEARCH_QUERY: `${VAULT_BASE_URL}/query/search`,
    CREATE_QUERY: `${VAULT_BASE_URL}/query/create`,
    GET_QUERY_BY_ID: `${VAULT_BASE_URL}/query`,
    UPDATE_QUERY: `${VAULT_BASE_URL}/query`,
    UPLOAD_QUERY_ATTACHMENT: `${VAULT_BASE_URL}/query/attachment`,
    QUERY_BASE: `${VAULT_BASE_URL}/query`,
    QUERY_CATEGORIES: `${VAULT_BASE_URL}/query/categories`,
    BULK_QUERY_TEMPLATE: `${VAULT_BASE_URL}/query/bulk-upload/template`,
    BULK_QUERY_UPLOAD: `${VAULT_BASE_URL}/query/bulk-upload`,
    QUERY_STATS: `${VAULT_BASE_URL}/query/stats`,
    ENTITY_TYPE_GROUPS: `${VAULT_BASE_URL}/query/entity-type-groups`,
    QUERY_ACTIONS: `${VAULT_BASE_URL}/query`,
    TRANSITION_QUERY: `${VAULT_BASE_URL}/query`,
    DOWNLOAD_ATTACHMENT: `${VAULT_BASE_URL}/query/query_attachments/`,
    ENTITY_META_DATA: `${MODEL_ENTITY_URL}/model-metadata`,
    WORKFLOW_LIFE_CYCLE_STAGE_DETAILS: `${MODEL_ENTITY_URL}/lifecycle-view/stage-details`,
    READ_ALL_MODEL_ENTITY: `${MODEL_ENTITY_URL}/readAll`,
    LITE_READ_ALL_MODEL_ENTITY: `${MODEL_ENTITY_URL}/readAllLite`,
    CREATE_MODEL_ENTITY_FIRST_STEP: `${MODEL_ENTITY_URL}/createModel`,
    CREATE_MODEL_ENTITY_SECOND_STEP: `${MODEL_ENTITY_URL}/updateModel/attribute`, // remove
    CREATE_MODEL_ENTITY_THIRD_STEP: `${MODEL_ENTITY_URL}/createModel/addModelAssociaton`,
    CREATE_MODEL_ENTITY_FORTH_STEP: `${MODEL_ENTITY_URL}/createModel/addModelTeam`,
    ATTRIBUTE_DETAILS: `${MODEL_ENTITY_URL}/get_attributes_data`,
    GET_HTML_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/render-html-attribute`,
    TEAM_DETAILS: `${MODEL_ENTITY_URL}/modelTeam`,
    ASSOCIATION_DETAILS: `${MODEL_ENTITY_URL}/read/modelAssociation`,
    ADD_SINGLE_TEAM_MEMBER: `${MODEL_ENTITY_URL}/createModel/addSingleTeam`,
    DELETE_ENTITY: `${MODEL_ENTITY_URL}/removeModel`,
    MODEL_APPROVE: `${VAULT_BASE_URL}/workflow/NextStage`,
    FORCE_MODEL_APPROVE: `${VAULT_BASE_URL}/workflow/forceNextStage`,
    SAVE_FILTER: `${VAULT_BASE_URL}/savesearch`,
    REMOVE_TEAM_MEMBER: `${MODEL_ENTITY_URL}/removeModel/teamMember`,
    REMOVE_MODEL_ASSOCIATION: `${MODEL_ENTITY_URL}/removeModel/association`,
    GET_SINGLE_ENTITY: `${MODEL_ENTITY_URL}/readSingle`,
    HISTORY: `${MODEL_ENTITY_URL}/modelHistory`,
    GET_LOG_ACTIONS: `${MODEL_ENTITY_URL}/getLogactions`,
    GET_LOG_ACTIONS_ATTRIBUTES: `${MODEL_ENTITY_URL}/getLogattributes`,
    GET_NOTES: `${MODEL_ENTITY_URL}/modelNotes`,
    GET_REPLIES: `${VAULT_BASE_URL}/replies`,
    GET_TRANSITION_STATES: `${VAULT_BASE_URL}/transitionstates`,
    GET_LIFECYCLE_NOTES: `${VAULT_BASE_URL}/lifecycle-note`,
    NOTES: `${VAULT_BASE_URL}/notes`,
    ADD_NOTES: `${MODEL_ENTITY_URL}/updateModel/addNote`,
    DELETE_FILTER: `${VAULT_BASE_URL}/savesearch`,
    EDIT_FILTER: `${VAULT_BASE_URL}/search`,
    GET_ALERTS: `${VAULT_BASE_URL}/alerts`,
    UPDATE_MODEL: `${MODEL_ENTITY_URL}/updateModel/attribute`,
    EXCEL_IMPORT: `${VAULT_BASE_URL}/bulkupload/template`,
    EXCEL_UPLOAD: `${VAULT_BASE_URL}/bulkupload/upload/`,
    CREATE_VERSION: `${VAULT_BASE_URL}/createversion`,
    GET_VERSIONS: `${VAULT_BASE_URL}/getallversions`,
    ROLLBACK_VERSION: `${VAULT_BASE_URL}/rollbackversion`,
    VERSIONS_COMPARISON: `${VAULT_BASE_URL}/compare-version`,
    GET_REPORTS: `${VAULT_BASE_URL}/reports`,
    GET_CATEGORY: `${VAULT_BASE_URL}/category/`,
    LINK_REPORT: `${VAULT_BASE_URL}/report-type/link/`,
    REPORT_LIST: `${VAULT_BASE_URL}/report-list`,
    REPORT_TYPES: `${VAULT_BASE_URL}/report-types`,
    REPORT_PERMISSIONS: `${VAULT_BASE_URL}/report-types/permissions`,
    LINKED_REPORT_TYPES: `${VAULT_BASE_URL}/linked-reporttypes`,
    EXECUTE_SQL_QUERY: `${VAULT_BASE_URL}/sql/execute/`,
    EXECUTE_AND_SAVE_QUERY: `/api/sql/execute-and-save`,
    AI_SQL_QUERY_ASSISTANT: `${LLM_URL}/text-to-sql`,
    AI_SQL_SCHEMA_SYNC: `${LLM_URL}/sync-schema`,
    GENERATE_CHART: `${VAULT_BASE_URL}/sql/generate-graph/`,
    CHART_LIST: `${VAULT_BASE_URL}/sql/graph-list/`,
    VIEW_CHART: `${VAULT_BASE_URL}/sql/visualise-graph/`,
    GET_DATABASE_SCHEMA: `${VAULT_BASE_URL}/database/schema`,
    GET_SAMPLE_QUERY: `${VAULT_BASE_URL}/database/sample-queries`,
    REFRESH_DATABASE_SCHEMA: `${VAULT_BASE_URL}/database/refresh/`,
    EXPORT_REPORT_AS_EXCEL: `${VAULT_BASE_URL}/generate-report`,
    DOWNLOAD_GENERATED_REPORTS: `${VAULT_BASE_URL}/generated-reports/download`,
    DOWNLOAD_GENERATED_REPORT_LOG: `${VAULT_BASE_URL}/generated-reports/logs`,
    CATEGORY_LIST_REPORT: `${VAULT_BASE_URL}/generated-reports`,
    UPDATE_CANVAS: `${VAULT_BASE_URL}/canvas-template/update/`,
    GET_CANVAS: `${VAULT_BASE_URL}/canvas-template`,
    GET_SYNC_STATUS: `${VAULT_BASE_URL}/database/refresh-status/`,
    PREVIEW_PDF_REPORT: `${VAULT_BASE_URL}/generate-report`,
    POWER_BI_REPORT: `${VAULT_BASE_URL}/PowerBI/Reports`,
    VIEW_REPORTS: `${VAULT_BASE_URL}/view-generated-report`,
    SCHEDULE_REPORT: `${VAULT_BASE_URL}/schedule`,
    GET_CURRENT_STATES: `${MODEL_ENTITY_URL}/status`,
    GET_MODEL_LINAGE: `${VAULT_BASE_URL}/graphplotforsingleentity/getnodes`,
    WORKFLOW_CHECKLIST: `${VAULT_BASE_URL}/workflow/checklist`,
    ALERT_EVENT: `${MODEL_ENTITY_URL}/alert_events`,
    MODEL_AVAILABLE: `${MODEL_ENTITY_URL}/available`,
    SAVE_DRAFT: `${VAULT_BASE_URL}/draft`,
    DRAFT_HISTORY: `${VAULT_BASE_URL}/draft/history`,
    GET_FIELDS_DATA_TYPES: `${MODEL_ENTITY_URL}/getDataType`,
    GET_STATE_DETAILS: `${MODEL_ENTITY_URL}/StatesDetails`,
    GET_SHOW_IN_SUMMARY: `${MODEL_ENTITY_URL}/showInSummary`,
    GET_TEMPLATE_ASSOCIATIONS: `${MODEL_ENTITY_URL}/getLifecycleDetails`,
    GET_PARENT_ASSOCIATION: `${MODEL_ENTITY_URL}/read/parentAssociation`,
    ISSUE_DATA: `${MODEL_ENTITY_URL}/read/validationArtifacts`,
    GET_ALL_ARTIFACTS_LIST: `${MODEL_ENTITY_URL}/read/sub-processes`,
    SEARCH_MODELS: `${VAULT_BASE_URL}/search-notes-entity`,
    GET_GLOBAL_ATTRIBUTE_VALUE: `${VAULT_BASE_URL}/globalattribute-value`,
    GET_LOCAL_ATTRIBUTE_VALUE: `${VAULT_BASE_URL}/attribute-value`,
    GET_MODEL_PREVIOUS_STATE: `${MODEL_ENTITY_URL}/getModelPreviousState`,
    PRECHECK_TRANSITION: `${MODEL_ENTITY_URL}/precheck-transition`,
    RECLAIM_STATE: `${MODEL_ENTITY_URL}/modelReclaim`,
    DOWNLOAD_INVENTORY_VIEW_REPORT: `${MODEL_ENTITY_URL}/inventory-view-download-report`,
    DOWNLOAD_LOGS: `${MODEL_ENTITY_URL}/modelHistoryDownload`,
    GET_USER_ROLE_PERMISSIONS: `${MODEL_ENTITY_URL}/getUserPermission`,
    GET_MAPPED_VALUES: `${MODEL_ENTITY_URL}/getMappedValues`,
    DOWNLOAD_REPORTS_DOCUMENT: `${VAULT_BASE_URL}/activityReport`,
    GET_ALL_ASSOCIATIONS: `${MODEL_ENTITY_URL}/get_all_associations`,
    ARCHIVE_ENTITY: `${MODEL_ENTITY_URL}/archive`,
    DOWNLOAD_REPORT_ENTITIES: `${MODEL_ENTITY_URL}/report-download`,
    ENTITY_STATUSES: `${MODEL_ENTITY_URL}/dropdownAttributes`,
    DOWNLOAD_CONNECTIVITY_REPORT: `${MODEL_ENTITY_URL}/report-architecture`,
    GET_ATTRIBUTES_COMMENTS: `${MODEL_ENTITY_URL}/attribute-comments`,
    DOWNSTREAM_ENTITIES: `${MODEL_ENTITY_URL}/get-downstream-entities`,
    ADD_SUB_ROLES: `${MODEL_ENTITY_URL}/addSubRoles`,
    GET_APPROVAL_DETAILS: `${VAULT_BASE_URL}/workflow/getApprovalDetails`,
    UPLOAD_FILE_FOR_ATTRIBUTE: `${VAULT_BASE_URL}/upload-document-for-attribute`,
    GET_ATTRIBUTE_SOURCE_MAPPING: `${MODEL_ENTITY_URL}/attribute-source-mapping`,
    UPDATE_USER_DETAILS: `${MODEL_ENTITY_URL}/updateTeamMember`,
    GET_LOG_STATE: `${MODEL_ENTITY_URL}/getLogstates`,
    FREEZE_STATE: `${MODEL_ENTITY_URL}/freeze_entity`,
    CLONE_ENTITY: `${MODEL_ENTITY_URL}/clone_artifact`,
    SECTION_PERMISSIONS: `${MODEL_ENTITY_URL}/section-permissions`,
    UPDATE_ARTIFACT_CYCLE: `${MODEL_ENTITY_URL}/update-artifact-cycle`,
    CYCLE_SIDEBAR_DATA: `${MODEL_ENTITY_URL}/cycles`,
    GET_CALCULATION_RELATED_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/calculation-related-attributes`,
    CALCULATE_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/calculate-attribute-value`,
    OVERRIDE_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/override-attribute-value`,
    GET_OVERRIDE_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/override-attribute-value`,
    GET_DOWNSTREAM_UPSTREAM_ENTITIES: `${VAULT_BASE_URL}/getUpstreamDownstreamEntities`,
    MAKER_CHECKER: `${MODEL_ENTITY_URL}/workflowMakerChecker`,
    CONSTRAINT_SOURCES: `${MODEL_ENTITY_URL}/get-constraint-sources`,
    GET_CONSTRAINTS: `${MODEL_ENTITY_URL}/get-constraint`,
    GET_ASSOCIATION_ATTRIBUTES_DATA: `${MODEL_ENTITY_URL}/getAssociationAttributesData`,
    GET_USERS_ATTRIBUTES_DATA: `${MODEL_ENTITY_URL}/getUsersAttributesData`,
    GROUP_DETAILS: `${MODEL_ENTITY_URL}/group-details`,
    GET_IMPACTED_ATTRIBUTES_DATA: `${MODEL_ENTITY_URL}/getImpactedAttributeData`,
    GET_INVENTORY_VIEW: `${MODEL_ENTITY_URL}/get-inventory-view`,
    RAISE_REQUEST_FOR_ENTITY: `${MODEL_ENTITY_URL}/RaiseRequestForEntity`,
    LINKED_ENTITIES: `${MODEL_ENTITY_URL}/linked-entites`,
    LINKED_ENTITIES_COLUMN_CONFIG: `${MODEL_ENTITY_URL}/linked-entities/column-config`,
    GET_LINKED_TEMPLATE_ENTITIES: `${MODEL_ENTITY_URL}/get-linked-template-entities`,
    ADVANCED_VARIABLES: `${VAULT_BASE_URL}/advanced-variables`,
    ADVANCED_VARIABLES_CRUD: `${VAULT_BASE_URL}/advanced-variables/manage`,
    CALCULATE_ADV_TABLE_ROW: `${VAULT_BASE_URL}/advanced-table/calculate-row/`,
    GET_ADV_TABLE_COLUMN_CONSTRAINTS: `${VAULT_BASE_URL}/advanced-table/get-column-constraints/`,
    GET_ADV_TABLE_CONSTRAINT_SOURCES: `${VAULT_BASE_URL}/get-adv-constraint-sources/`,
    PRECHECK_ADVANCED_TABLE: `${VAULT_BASE_URL}/precheck-advanced-table/`,
    APPROVE_SEGMENT_TRANSITION: `${MODEL_ENTITY_URL}/approve-segment-transition`,
    GET_CHANGE_REQUEST_FIELD_OPTIONS: `${CHANGE_REQUEST_IMPACT}/constants/field-change-map`,
    GET_IMPACT_ANALYSIS: `${CHANGE_REQUEST_IMPACT}/get-impact`,
    ATTRIBUTE_LIST_KEYS: `${ENTITIES_URL}/attributes/dropdown`,
    ATTRIBUTE_LIST_VALUES: `${ENTITIES_URL}/attributes/dropdown/values`,
    META_DATA: `${MODEL_ENTITY_URL}/model-meta-data`,
    BEDROCK_OPTION_LIST: `${VAULT_BASE_URL}/bedrock/resources`,
    ENTITY_ISSUE_TYPE_COUNTS: `${MODEL_ENTITY_URL}/metadata`,
    GET_ONGOING_PROCESSES: `${ENTITY_SERVICE_URL}/ongoingProcesses`,
  },
  DOC: {
    MODEL_DOCUMENTS: `${VAULT_BASE_URL}/document`,
    UPLOAD_DOCUMENTS: `${VAULT_BASE_URL}/upload-document`,
    EDIT_DOCUMENTS: `${VAULT_BASE_URL}/edit_document`,
    DOCUMENT_TREE: `${VAULT_BASE_URL}/doc_tree`,
    DOWNLOAD_DOCUMENT: `${VAULT_BASE_URL}/export-document`,
    REPLACE_DOCUMENT: `${VAULT_BASE_URL}/update-document`,
    UPLOAD_CHUNK: `${VAULT_BASE_URL}/upload-chunk`,
    START_UPLOAD: `${VAULT_BASE_URL}/start-upload`,
    COMPLETE_UPLOAD: `${VAULT_BASE_URL}/complete_upload`,
    UPDATE_DOCUMENT: `${VAULT_BASE_URL}/update-document`,
    ASSOCIATED_DOCUMENT: `${VAULT_BASE_URL}/associated-document`,
    ATTRIBUTE_DOCUMENT: `${VAULT_BASE_URL}/attibute-document`,
  },
  SCHEMA: {
    START_UPLOAD: `${VAULT_BASE_URL}/constants/excel/start-upload`,
    UPLOAD_CHUNK: `${VAULT_BASE_URL}/constants/excel/upload-chunk`,
    COMPLETE_UPLOAD: `${VAULT_BASE_URL}/constants/excel/complete-upload`,
  },
  RR: {
    RULES: `${VAULT_BASE_URL}/rules`,
    ADVANCED_REPORT_QUERIES: `${VAULT_BASE_URL}/advanced-report-queries`,
  },
  RAD: {
    // Report APIs
    GET_REPORTS: `${RAD_URL}/reports/report-list`,
    GET_REPORT_FILTER: `${RAD_URL}/reports/report-list-filter`,
    GET_REPORT_HISTORY: `${RAD_URL}/reports/report-history-list`,
    GET_REPORT_DATA_SCHEMA: `${RAD_URL}/reports/data/schema`,
    COPY_REPORT: `${RAD_URL}/reports/copy-report`,
    GENERATE_REPORT: `${RAD_URL}/reports/generate-report`,
    BULK_REPORTS_DATA: `${RAD_URL}/reports/reports-data`,
    EXPORT_REPORT: `${RAD_URL}/reports/export-report`,
    REPORT: `${RAD_URL}/reports/report`,

    // Dashboard APIs
    CRUD_DASHBOARD: `${RAD_URL}/dashboard`,
    GET_DASHBOARDS: `${RAD_URL}/dashboard`,
    GET_DASHBOARD_FILTER: `${RAD_URL}/dashboard/dashboard-list-filter`,
    COPY_DASHBOARD: `${RAD_URL}/dashboard/copy-dashboard`,
    PUBLISH_DASHBOARD: `${RAD_URL}/dashboard/publish-dashboard`,
    EXPORT_DASHBOARD: `${RAD_URL}/dashboard/export-dashboard`,
    DRAFT_DASHBOARD: `${RAD_URL}/dashboard/draft-dashboard`,
    Add_HOMEPAGE: `${RAD_URL}/dashboard/add-homepage`,
    GET_HOMEPAGE: `${RAD_URL}/dashboard/homepage`,

    // Repository APIs
    REPOSITORY: `${RAD_URL}/repository/repository`,
    FOLDER_RENAME: `${RAD_URL}/repository/rename-folder`,

    // SQL APIs
    GET_QUERY_FROM_NO_CODE_JSON: `${RAD_URL}/reports/build-query`,
    EXECUTE_SQL_EDITOR_QUERY: `${RAD_URL}/reports/data/execute`,
    GET_REPORT_DATA_SYNC_VIEWS: `${RAD_URL}/reports/data/sync-views`,
    REFRESH_REPORT_DATA_VIEWS: `${RAD_URL}/reports/data/refresh-views`,

    // common
    REPORT_ACCESS: `${RAD_URL}/permissions`,
  },
  GA: {
    GLOBAL_ATTRIBUTES: `${VAULT_BASE_URL}/globalattributes`,
    GLOBAL_ATTRIBUTE_ORDER: `${VAULT_BASE_URL}/globalattribute-order`,
  },
  DB: {
    GET_FILTER: `${VAULT_BASE_URL}/savesearch`,
    GET_FILTERED_DATA: `${VAULT_BASE_URL}/search`,
    GET_NODES: `${VAULT_BASE_URL}/graphplot/getnodes/`,
    PLOT_GRAPH: `${VAULT_BASE_URL}/graphplot/plotgraph/`,
    FULL_SEARCH: `${VAULT_BASE_URL}/fullsearch`,
    PIPELINE: `${VAULT_BASE_URL}/pipeline`,
    DASHBOARD_REPORTS: `${VAULT_BASE_URL}/dashreports`,
    GET_ALERTS: `${VAULT_BASE_URL}/alert`,
    GET_KIBAN_DASHBOARD: `${VAULT_BASE_URL}/kibanadashboard`,
    GET_ALL_SAVED_SEARCH: `${VAULT_BASE_URL}/allsavedsearch`,
    GET_LANDSCAPE_SCHEMA: `${VAULT_BASE_URL}/model-landscape-schema`,
    USER_SELECTED_ENTITIES: `${VAULT_BASE_URL}/user-selected-entities`,
  },
  BU: {
    GET_FILES: `${BULK_UPLOAD_URL}/files/`,
    CREATE_MODEL: `${BULK_UPLOAD_URL}/create-model/`,
    DELETE_FILE: `${BULK_UPLOAD_URL}/files/delete`,
    DOWNLOAD_FILE: `${BULK_UPLOAD_URL}/downloadfile`,
  },
  TA: {
    THEME: `${VAULT_BASE_URL}/theme-customization`,
    USER_THEME_SETTINGS: `${VAULT_BASE_URL}/userThemeSettings`,
  },
  BA: {
    GET_ALL_MODELS: `${BULK_TRANSITION_URL}/allModel`,
    GET_STATES: `${BULK_TRANSITION_URL}/getState`,
    BULK_TRANSITION: `${BULK_TRANSITION_URL}/transition`,
    GET_BULK_TRANSITION_FILTER: `${BULK_TRANSITION_URL}/filter`,
  },
  NOTES: {
    COMMENTS: `${MODEL_ENTITY_URL}/model_comment`,
  },
  NUI: {
    GET_ALL_MODELS: `${VAULT_BASE_URL}/nimbus/getallmodels`,
    GET_ALL_PROJECTS: `${VAULT_BASE_URL}/nimbus/model-entity/getnimbusprojectlist`,
    INTEGRATE_ENTITY: `${VAULT_BASE_URL}/nimbus/model-entity/enablemodelintegration`,
    GET_ALL_PIPELINES: `${VAULT_BASE_URL}/nimbus/getpipelinelist`,
    RUN_PIPELINE: `${VAULT_BASE_URL}/nimbus/runpipeline`,
    PIPELINE_STATUS: `${VAULT_BASE_URL}/nimbus/getpipelinestatus`,
    GET_REDIRECTION_URL: `${VAULT_BASE_URL}/nimbus/redirection`,
    UNLINK_ENTITY: `${VAULT_BASE_URL}/nimbus/unlink_model`,
    GET_PIPELINE_TEMPLATES: `${VAULT_BASE_URL}/nimbus/pipeline-template-engine/templates`,
    CREATE_MATERIALIZED_PIPELINE: `${VAULT_BASE_URL}/nimbus/pipeline-template-engine/pipelines`,
  },
  LLM: {
    DOC_CHAT: `${LLM_URL}/chat`,
    ENTITY_CHAT: `${LLM_URL}/modelchat`,
    RAG_ENTITY_CHAT: `${LLM_URL}/rag/modelchat`,
    DOC_AVAILABLE: `${LLM_URL}/check`,
    DOC_UPLOAD: `${LLM_URL}/document`,
    ENTITY_UPLOAD: `${LLM_URL}/modeltrain`,
    DOWNLOAD_WEAKNESS_ASSESSMENT: `${LLM_URL}/v2/doc-assess`,
    DOC_ASSESS_RUNS: `${LLM_URL}/rag/doc-assess/runs`,
    DOC_ASSESS_RUNS_FILTER: `${LLM_URL}/rag/doc-assess/runs/filter`,
    DOC_ASSESS_REPORT: `${LLM_URL}/rag/doc-assess/report`,
    DOC_ASSESS_RUN: `${LLM_URL}/rag/doc-assess`,
    SUGGEST_FIELDS: `${LLM_URL}/suggest-fields`,
    MODEL_SESSIONS: `${LLM_URL}/model-sessions`,
    RAG_MODEL_SESSIONS: `${LLM_URL}/rag/model-sessions`,
    DOC_SESSIONS: `${LLM_URL}/document-chat-sessions`,
    RAG_DOC_CHAT: `${LLM_URL}/rag/document-chat`,
    RAG_DOC_SESSIONS: `${LLM_URL}/rag/document-chat-sessions`,
    RAG_DOC_AVAILABLE: `${LLM_URL}/rag/document`,
    LLM_BASED_FILTER: `${LLM_URL}/text-to-filter`,
    SYNC_ATTRIBUTES_TO_DOCSEARCH: `${LLM_URL}/sync-attributes-to-docsearch`,
  },
  SP: {
    GET_SHAREPOINT_FILES: `${VAULT_BASE_URL}/sharepoint/files`,
    SYNC_SHAREPOINT_FILES: `${VAULT_BASE_URL}/sharepoint/sync_document`,
    GET_PROCESS_NAMES: `${VAULT_BASE_URL}/sharepoint/get-processes`,
    GET_PROCESS_FILES: `${VAULT_BASE_URL}/sharepoint/get-process-files`,
    SUBMIT_FILES_FOR_MIGRATION: `${VAULT_BASE_URL}/sharepoint/pipeline`,
    SEARCH_INVENTORY: `${VAULT_BASE_URL}/sharepoint/search-files`,
    STOP_SEARCH: `${VAULT_BASE_URL}/sharepoint/stop_search`,
  },
  PGN: {
    FETCH_PLUGINS: `${AUTH_URL}/plugins`,
  },
  HELP_SUPPORT: {
    DOCUMENTS: `${VAULT_BASE_URL}/admin-help`,
    RESTRUCTURE: `${VAULT_BASE_URL}/admin-help/restructure`,
  },
  BULK_UPDATE: {
    GET_EXCEL_TEMPLATE: `${BULK_UPDATE_URL}/template/`,
    UPLOAD_TEMPLATE: `${BULK_UPDATE_URL}/upload/`,
    TRIGGER_UPDATE: `${BULK_UPDATE_URL}/update-attributes/`,
    FILE_LIST: `${BULK_UPDATE_URL}/files`,
    DELETE_FILE: `${BULK_UPDATE_URL}/files/delete`,
    BULK_UPDATE_ATTRIBUTES: `${VAULT_BASE_URL}/bulk-update/updateAttributes`,
    CREATE_BULK_ENTITIES: `${VAULT_BASE_URL}/bulk-create/entities`,
  },
  C_LOCK: {
    GET_LOCK: C_LOCK_URL,
    UPSERT_LOCK: C_LOCK_URL,
  },
  BULK_DOC_UPLOAD: {
    FILE_LIST: `${BULK_DOCUMENT_URL}/files`,
    DOWNLOAD_EXCEL: `${BULK_DOCUMENT_URL}/download-template`,
    UPLOAD_EXCEL: `${BULK_DOCUMENT_URL}/upload`,
    TRIGGER_UPDATE: `${BULK_DOCUMENT_URL}/process-docs`,
  },
  CNF: {
    TEMP: {
      ADD_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/addAttribute`,
      REMOVE_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/removeAttribute`,
      REORDER_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/reorderAttribute`,
      REORDER_SECTIONS: `${CUSTOM_ENTITY_URL}/reorderSection`,
      COLUMN_REORDER: `${CUSTOM_ENTITY_URL}/column-reorder`,
      GET_COLUMN_REORDER: `${CUSTOM_ENTITY_URL}/column-reorder`,
    },
    DYT: {
      GET_ALL_TOOLBARS_LIST: `${DYNAMIC_TOOLBAR_URL}`,
      GET_SIDEBAR_OPTIONS: `${DYNAMIC_TOOLBAR_URL}/options`,
      GET_TEMPLATE_BY_ID: `${DYNAMIC_TOOLBAR_URL}/template`,
      CREATE_TOOLBAR: `${DYNAMIC_TOOLBAR_URL}`,
      UPDATE_TOOLBAR: `${DYNAMIC_TOOLBAR_URL}`,
    },
    ACT: {
      GET_ACTIONABLE_BY_NODE: `${CUSTOM_ENTITY_URL}/actionables/configured`,
      CREATE_ACTIONABLE: `${CUSTOM_ENTITY_URL}/template/actionable`,
      DELETE_ACTIONABLE_BY_ID: `${CUSTOM_ENTITY_URL}/template/actionable`,
      GET_ACTIONABLES: `${CUSTOM_ENTITY_URL}/actionables`,
      REORDER_ACTIONABLES: `${CUSTOM_ENTITY_URL}/actionables/reorder`,
      CONFIGURED_ACTIONABLE: `${CUSTOM_ENTITY_URL}/actionables/configured`,
    },
  },
  SEGMENTS: {
    GET_SEGMENTS: `${MODEL_ENTITY_URL}/segments`,
    CREATE_SEGMENT: `${MODEL_ENTITY_URL}/segments`,
    UPDATE_SEGMENT: `${MODEL_ENTITY_URL}/segments`,
    DELETE_SEGMENT: `${MODEL_ENTITY_URL}/segments`,
    DUPLICATE_SEGMENT: `${MODEL_ENTITY_URL}/segment-duplicate-check`,
    CHECK_INPROGRESS: `${MODEL_ENTITY_URL}/segment-progress`,
  },
  SECTIONS: {
    GET_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
    CREATE_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
    UPDATE_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
    DELETE_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
  },
};
export default API_ENDPOINTS;
